import { Card, CardContent } from '@/components/ui/card';

interface NarrativePanelProps {
  prompt: string;
}

export function NarrativePanel({ prompt }: NarrativePanelProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <p className="text-lg leading-relaxed">{prompt}</p>
      </CardContent>
    </Card>
  );
}
